// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_i2-0";
export var actionModalContentContainer = "_i2-1";
export var createTagButton = "_i2-2";
export var footerContainer = "_i2-7";
export var fullWidthDivider = "_i2-3";
export var hasCreateTagButton = "_i2-4";
export var noCreateTagButton = "_i2-5";
export var tagsContainer = "_i2-6";
export var tagsModalContentContainer = "_i2-8";